import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Avatar from '@material-ui/core/Avatar';
import CardHeader from '@material-ui/core/CardHeader';
import MessageContent from "./MessageContent";

const styles = theme => ({

    cardHeader: {
        padding: theme.spacing(2)
    },
    onlineDot: {
        position: 'absolute',
        top: 0,
        right: 0,
        background: 'rgb(112, 213, 38)',
        borderRadius: 8,
        width: 12,
        height: 12,
        border: '2px solid white',
    },
    avatar: {
        position: 'relative',
    },
    sendIcon: {},
    iconButtonRoot: {
        width: 42,
        height: 42,
        margin: '8px 8px 0 0',
        padding: 0,
    },
});

class Header extends PureComponent {
    state = {isLoading: false};

    render() {
        const {classes, bot} = this.props;
        const {isLoading} = this.state;

        return (<CardHeader
                classes={{root: classes.cardHeader}}
                avatar={<div className={classes.avatar}>
                    <Avatar alt={bot.name} src={bot.img}
                    />
                    <div className={classes.onlineDot}></div>
                </div>
                }
                action={
                    <IconButton classes={{root: classes.iconButtonRoot}}>
                        <FontAwesomeIcon size={'lg'} icon={['fal', 'ellipsis-v']}
                                         className={classes.sendIcon}/>
                    </IconButton>
                }
                title={bot.name}
                subheader={bot.description}
            />
        );
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
